import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-refund-amount',
  templateUrl: './refund-amount.component.html',
  styleUrls: ['./refund-amount.component.scss']
})
export class RefundAmountComponent implements OnInit,OnDestroy{
  link = new FormControl();
  amount = new FormControl();
  private destroy$ = new Subject<void>();
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<RefundAmountComponent>){}

  ngOnInit(): void {
    if(this.data.isLink){
      this.amount.clearValidators();
      this.link.setValidators(Validators.required);
      this.link.updateValueAndValidity();
    }else{
      this.link.clearValidators();
      if(this.data?.amount){
        this.amount.setValue(this.data.amount)
      }
      this.amount.setValidators(Validators.required);
      this.amount.updateValueAndValidity();
    }
  }

  action(event){
    if(event == 'Save'){
     this.dialogRef.close({link:this.link.value,refundedAmount:this.amount.value})
    }else{
      this.close();
    }
  }

  close(){
    this.dialogRef.close();
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
